import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function activateAutomaticPayments(input: { enrollmentId: number }) {
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.activateAutomaticPayments.url, {
        id: input.enrollmentId
      })
    )
    .post<never>()
}

export function deactivateAutomaticPayments(input: { enrollmentId: number }) {
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.deactivateAutomaticPayments.url, {
        id: input.enrollmentId
      })
    )
    .post<never>()
}
